<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
	  <el-button type="primary" @click="handleExport"
	    ><i class="el-icon-download"></i> 导出</el-button
	  >
      <BaseTable
        ref="baseTable"
        url="/admin/Census/creatorbusList"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
      >
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Whole",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
	  creatorNoList: [],
      searchData: {},
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrg();
	this.CreatorNoList();
  },
  methods: {
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
	CreatorNoList() {
	  this.$api.post("/admin/admin/getCreatorNo", {}).then((res) => {
	    this.creatorNoList = res.data;
	  });
	},
	async handleExport() {
	  const res = await this.$api.post(
	    "/admin/Census/creatorbusList",
	    { is_export: 1, ...this.searchData },
	    "导出"
	  );
	  window.open("https://" + res.data);
	},
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
